<div class="bar-chart">
  <canvas baseChart
    [datasets]="barChartData"
    [labels]="barChartLabels"
    [options]="barChartOptions"
    [legend]="false"
    [type]="chartType">
  </canvas>
</div>